import { FormattedMessage } from 'react-intl';

import VIEW_MODES from 'shared/constants/view-modes';
import { WixConnect } from 'shared/utils/wix-connect';

import WixSDK from 'shared/utils/wix-sdk';
import { openModal, closeModal, closeCatcher } from 'shared/components/modal/modal';
import { PrimaryButton } from 'shared/components/button/button';

import styles from './preview-prompt.styl';

import translations from './translations';


@WixConnect(styles)
class PreviewModePrompt extends React.Component {

  render() {
    return (
      <div styleName="prompt-wrapper"
           className="qa-widget-preview-prompt">
        <div styleName="first-message">
          <FormattedMessage {...translations.youInPreview1} />
        </div>
        <div styleName="second-message">
          <FormattedMessage {...translations.youInPreview2} />
        </div>
        <PrimaryButton styleName="close-button"
                       onClick={closeModal}>
          <FormattedMessage {...translations.gotIt} />
        </PrimaryButton>
      </div>
    );
  }
}

export function isPreviewMode() {
  return WixSDK.Utils.getViewMode() === VIEW_MODES.PREVIEW;
}

export function openPreviewPrompt() {
  openModal({
    contentClassName: styles['modal-content'],
    className: styles.modal,
    closeOnOverlayClick: true,
    title: <FormattedMessage {...translations.previewMode} />,
    content: <PreviewModePrompt />,
  })
    .catch(closeCatcher);
}

export function handlePreview(callBack) {
  return function () {
    if (isPreviewMode()) {
      openPreviewPrompt();
      return null;
    }

    callBack();
  };
}



// WEBPACK FOOTER //
// ./src/widget/components/preview-prompt/preview-prompt.js